import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorCorrectionHeaderCreate = () => {
  const { t } = useTranslation()
  const correctionHeaderCreate = useCallback(
    (payload, callback = () => {}, loading = () => {}) => {
      ApiService.jsonRequest('/transaction-correction-header/create', payload, (response) => {
        loading(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_added`),
            timer: 2000,
          })
          callback(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 2000,
          })
        }
      })
    },
    [t],
  )
  return { correctionHeaderCreate }
}

export default InteractorCorrectionHeaderCreate
